import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { banksApi } from "../../app/slices/banksSlice";
import { Box, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import { ContentCopy } from "@mui/icons-material"; // Import the copy icon from MUI
import NameSearchComponent from "../../components/customTable/NameSearchComponent";
import DateSearchComponent from "../../components/customTable/DateSearchComponent";

import { useMediaQuery, useTheme } from "@mui/material";
import Filter from "../../components/Filter";
import { useFormik } from "formik";
// import { Import, Loader } from "lucide-react";
import Loader from "../digitalGold/Loader";
import useFilterHandler from "../../components/filterhandler";

export default function Banks() {
  const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(banksApi());
  // }, [dispatch]);

  
  const [filterData, setFilterData] = useState({
   
    name: "",
   
    customerRefNo: "",
    // bankAccNo:"",
    accountNo:"",
    startDate:"",
    endDate:"",

  });
  const url = `/api/admin/bank/list`
    
      const { handleFilterSubmit, handleClearFilters, loader, results, apiCall,message,error,toastTrigger } = useFilterHandler(url, filterData, setFilterData)

  useEffect(() => {
     // setUsersList(sliceResponse);
     // useFilterHandler(url, filterData,setFilterData)
     apiCall(false)
   }, []);
 
    useEffect(() => {
   if (!message) return;
 
   console.log("Message updated:", message);
 
   if (error) {
     toast.error(message);
   }
  //   else {
  //    // toast.success(message);
  //  }
 }, [toastTrigger]);
  const sliceResponse = useSelector((state) => state.banks.banks.data);
  const stateLoading = useSelector(
    (state) => state.banks.loading
  );

  // loading={stateLoading}
  const columnHelper = createMRTColumnHelper();

  const columns = [
    columnHelper.accessor("customerRefNo", {
      header: "Customer Ref No",
      size: 200,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.customerRefNo);
          toast.success("copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row.original?.customerRefNo}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.customerRefNo}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("name", {
      header: "Name",
      size: 200,
      Cell: (cell) => cell.row.original?.name,
    }),
    columnHelper.accessor("customerName", {
      header: "Profile Name",
      size: 200,
      Cell: (cell) => cell.row.original?.customerName,
    }),
     columnHelper.accessor("account_no", {
      header: "Account Number",
      size: 200,
      Cell: (cell) => cell.row.original?.account_no,
    }),
    columnHelper.accessor("ifsc", {
      header: "IFSC Code",
      size: 150,
      Cell: (cell) => cell.row.original?.ifsc,
    }),
    //   columnHelper.accessor("Bankname", {
    //   header: "Bank Name",
    //   size: 200,
    //   Cell: (cell) => cell.row.original?.Bankname,
    // }),
    // columnHelper.accessor("Branchname", {
    //   header: "Branch Name",
    //   size: 200,
    //   Cell: (cell) => cell.row.original?.Branchname,
    // }),

    columnHelper.accessor("bankStatus", {
      header: "Bank Status",
      size: 100,
      Cell: (cell) => cell.row.original?.bankStatus,
    }),
    columnHelper.accessor("status", {
      header: "Status",
      size: 100,
      Cell: (cell) => cell.row.original?.status,
    }),
    columnHelper.accessor("description", {
      header: "Description",
      size: 250,
      Cell: (cell) => cell.row.original?.description,
    }),
    columnHelper.accessor("transID", {
      header: "Transaction ID",
      size: 150,
      Cell: (cell) => cell.row.original?.transID,
    }),
    columnHelper.accessor("tsTransID", {
      header: "TS Transaction ID",
      size: 200,
      Cell: (cell) => cell.row.original?.tsTransID,
    }),
  
   
    columnHelper.accessor("createdAt", {
      header: "Created Date",
      size: 150,
      Cell: (cell) => {
        const date = cell.row.original?.createdAt?.split("T")[0];
        return date;
      },
    }),

    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 150,
      Cell: (cell) => {
        const date = cell.row.original?.updatedAt?.split("T")[0];
        return date;
      },
    }),
  ];

  // Local state to manage search terms
  const [searchTerm, setSearchTerm] = useState(""); // For name search
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  }); // For date search

  // useEffect(() => {
  //   if (searchTerm) {
  //     // If searchTerm is provided, search by name
  //     dispatch(banksApi({ name: searchTerm }));
  //   } else if (queryParams.startDate && queryParams.endDate) {
  //     // If startDate and endDate are provided, search by date range
  //     dispatch(banksApi(queryParams));
  //   } else {
  //     // Default API call without filters
  //     dispatch(banksApi({}));
  //   }
  // }, [dispatch, searchTerm, queryParams]);

  const handleSearchByDate = (startDate, endDate) => {
    setSearchTerm(""); // Clear name search when using date search
    setQueryParams({ startDate, endDate });
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // ✅ Mobile screen check
  //--------------------newcode----------
 


  return (
    <>
     <Filter filterData={filterData} onFilterSubmit={handleFilterSubmit} Onclear={handleClearFilters} page={'Bank'} setFilterData={setFilterData} />
      {/* */}
      <Box>
        <Box
          display="flex"
          flexDirection={isMobile ? "column" : "row"} // ✅ Stack vertically on mobile
          alignItems={isMobile ? "stretch" : "center"}
          justifyContent={isMobile ? "flex-start" : "space-between"}
        >
          {/* <Box width={isMobile ? "100%" : "40%"}>
            <NameSearchComponent
              onSearch={(name) => {
                setQueryParams({ startDate: null, endDate: null }); // Clear date search when using name search
                setSearchTerm(name);
              }}
              placeholderName="Search by Name or Bank"
            />                </Box>

          <Box
            width={isMobile ? "100%" : "55%"}
            mt={isMobile ? 2 : 0}
            ml={isMobile ? 0 : 0}
          > */}
            {/* <DateSearchComponent onSearch={handleSearchByDate} /> */}
          {/* </Box> */}
        </Box>
        <Box mt={2} >
         {loader?<Loader/>:<CustomTable columns={columns} data={results} loading={loader} permissionKey="Banks"
          />} 
        </Box>
      </Box>
      {/* <>
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <NameSearchComponent
            onSearch={(name) => {
              setQueryParams({ startDate: null, endDate: null }); // Clear date search when using name search
              setSearchTerm(name);
            }}
          />

          <DateSearchComponent onSearch={handleSearchByDate} />
        </Box>
        <CustomTable columns={columns} data={sliceResponse} loading={stateLoading} />
      </> */}

    </>
  );
}
